import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";
import type { RouterOutputs } from "@/trpc";

export type OrgAwaitingSubmissionShift =
  RouterOutputs["timeEntry"]["getAwaitingSubmissionShiftsForOrg"][number];

export interface AwaitingSubmissionFilters {
  weekKey?: string;
  facilityId?: string;
  providerSearch?: string;
}

/**
 * Hook to fetch shifts that are past but don't have time entries yet.
 * Returns shifts where providers haven't submitted their timesheets.
 */
export function useAwaitingSubmissionShifts(
  organizationBusinessUnitId: string | undefined,
  filters: AwaitingSubmissionFilters = {},
) {
  const trpc = useTRPC();

  const {
    data: shifts,
    isLoading,
    error,
    refetch,
  } = useQuery(
    trpc.timeEntry.getAwaitingSubmissionShiftsForOrg.queryOptions(
      {
        organizationBusinessUnitId: organizationBusinessUnitId!,
        weekKey: filters.weekKey,
        facilityId: filters.facilityId,
        providerSearch: filters.providerSearch,
      },
      {
        enabled: !!organizationBusinessUnitId,
        refetchInterval: 30_000,
      },
    ),
  );

  return {
    shifts: shifts ?? [],
    isLoading,
    error,
    refetch,
  };
}
